// Shared chart colors used across all charts in the application
// Originally from AnalysisPage, now centralized for consistency

export const SERVICE_COLORS = [
    '#019EE3',
    '#FF5A34',
    '#FEC248',
    '#60419D',
    '#9F9BE8',
    '#058DAD',
    '#25C8FF',
    '#6BB4C5',
    '#CA78D5',
    '#F38F78',
    '#DF0073',
    '#5EAF6C',
    '#78E78B',
    '#4EBFCF',
    '#001B5A',
];

// Helper function to get a color by index with cycling
export const getChartColor = (index: number): string => {
    return SERVICE_COLORS[index % SERVICE_COLORS.length];
};

// Helper function to get colors for an array of items
export const getColorsForItems = (items: string[]): Record<string, string> => {
    const colorMap: Record<string, string> = {};
    items.forEach((item, index) => {
        colorMap[item] = getChartColor(index);
    });
    return colorMap;
};

// Cost category colors for unified cost view
// Using distinct, accessible colors that work well together
export const COST_CATEGORY_COLORS: Record<string, string> = {
    'maintenance-utility': '#3B82F6',    // Blue - fastighetsteknik
    'maintenance-other': '#8B5CF6',      // Purple - underhåll byggnad
    'project-investment': '#F97316',     // Orange - projektinvestering
    'inspection': '#F59E0B',             // Amber - kontroller
    'operating-cost': '#10B981',         // Green - driftkostnader
    'rental-income': '#059669'           // Emerald green - hyresintäkter (income)
};

// Swedish labels for cost categories
export const COST_CATEGORY_LABELS: Record<string, string> = {
    'maintenance-utility': 'Underhåll fastighetsteknik',
    'maintenance-other': 'Underhåll byggnad',
    'project-investment': 'Investering',
    'inspection': 'Kontroller',
    'operating-cost': 'Driftkostnader',
    'rental-income': 'Hyresintäkter'
};

// All cost categories in display order (rental-income excluded as it's income, not cost)
export const COST_CATEGORIES = [
    'maintenance-utility',
    'maintenance-other',
    'project-investment',
    'inspection',
    'operating-cost'
] as const;

// Income categories (separate from cost categories)
export const INCOME_CATEGORIES = ['rental-income'] as const;

// All financial categories (costs + income) for filtering
export const ALL_FINANCIAL_CATEGORIES = [
    ...COST_CATEGORIES,
    ...INCOME_CATEGORIES
] as const;
